import type { HouseholdInsightsApiResponse } from '../apiTypes';
import type { DistributionItem } from '../chartTypes';
import { HOUSEHOLD_CTV_BUCKETS } from '../constants';
import { parseDistribution } from './utils';

export const parseHouseholdCtvs = (response: HouseholdInsightsApiResponse | undefined): DistributionItem[] =>
  parseDistribution(response?.household_ctvs, HOUSEHOLD_CTV_BUCKETS);
